import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    width: 100%;
  }

  .manage-create-modal-header {
    color: var(--sds-color-text-default-default);
    font-family: var(--sds-typography-family-title), sans-serif;
    font-size: var(--sds-typography-scale-02);
    font-weight: var(--sds-typography-weight-medium);
  }
`;
